import React from 'react';
import { Input, InputProps } from './Input';

export const PhoneInput = ({ value = '', ...props }: InputProps) => {
  return <Input value={value} isPhone {...props} />;
};
